import { Colors } from '../../Colors'
import { Options } from '../../Options'
import { ChartLineConstants } from './ChartLine.constants'

export const chartLineOptions = Options.asRecord(
  Options.createOption({
    key: 'fillArea',
    inputKind: 'boolean',
    defaultValue: false,
    label: 'Fill area',
    description: 'Fill the area under each line series.',
    category: 'Line',
  }),
  Options.createOption({
    key: 'fillOpacity',
    inputKind: 'number',
    defaultValue: ChartLineConstants.defaultFillOpacity,
    min: 0,
    max: 1,
    step: 0.05,
    label: 'Fill opacity',
    description: 'Opacity of the area fill under each line.',
    category: 'Line',
  }),
  Options.createOption({
    key: 'curveType',
    inputKind: 'select',
    selectChoices: [
      { value: 'linear', label: 'Linear' },
      { value: 'smooth', label: 'Smooth' },
      { value: 'step', label: 'Step' },
    ],
    defaultValue: ChartLineConstants.defaultCurveType,
    label: 'Curve type',
    description: 'Interpolation used when connecting line points.',
    category: 'Line',
  }),
  Options.createOption({
    key: 'showDataPoints',
    inputKind: 'boolean',
    defaultValue: true,
    label: 'Show data points',
    description: 'Render circular markers at each data point.',
    category: 'Line',
  }),
  Options.createOption({
    key: 'pointRadius',
    inputKind: 'number',
    defaultValue: ChartLineConstants.defaultPointRadius,
    min: 1,
    max: 12,
    step: 1,
    label: 'Point radius',
    description: 'Fill radius of data-point markers in pixels.',
    category: 'Line',
  }),
)

export type ChartLineOptions = Options.TypeOf<typeof chartLineOptions>
export type ChartLineCurveType = Options.ResolvedTypeOf<
  typeof chartLineOptions
>['curveType']
export type { ChartColorPalette } from '../../Colors'
export type { ChartLineStyle } from '../ChartMark'
export const mapColorPalette = Colors.mapColorPalette
